import React from 'react';
import MediaQuery from 'react-responsive';

import * as constants from 'common/constants';

// These breakpoints are deprecated. Use "browser" from redux instead
// (redux-responsive)
export const Mobile = props => (
  <MediaQuery {...props} maxWidth={constants.BREAKPOINT_MOBILE_MAX} />
);
export const Desktop = props => (
  <MediaQuery {...props} minWidth={constants.BREAKPOINT_DESKTOP_MIN} />
);



// WEBPACK FOOTER //
// ./src/common/components/Responsive/index.js